import {
  loadCardSettings,
  saveCardSettings,
} from "../services/scoreCardSettings";

export const APPLY_SETTINGS_CARD = "APPLY_SETTINGS_CARD";
export const SAVE_SETTINGS_CARD = "SAVE_SETTINGS_CARD";
export const LOAD_SETTINGS_CARD = "LOAD_SETTINGS_CARD";

const initState = [
  {
    type: 1,
    settings: {
      throwsStyle: {
        fontColor: "#000000",
        fontSize: "12px",
        fontBold: false,
      },
      currentFrame: {
        lowFrameBackground: "#fdffab",
        topFrameBackground: "#ffd873",
      },
      topFrameBackground: "#c4c4c4",
      scoresContainerBackground: "#fff",
      framesContainerBackground: "#959595",
      sectionContainerBackground: "#959595",
      showLaneNumber: true,
      playerName: {
        fontColor: "#000000",
        fontSize: "20px",
        fontBold: false,
      },
      frameScore: {
        fontColor: "#000000",
        fontSize: "16px",
        fontBold: false,
      },
    },
  },
  {
    type: 2,
    settings: {
      throwsStyle: {
        fontColor: "#000000",
        fontSize: "13px",
        fontBold: false,
      },
      currentFrame: {
        lowFrameBackground: "#5ea311",
        topFrameBackground: "#5ea311",
      },
      scoresContainerBackground: "#2c2d30",
      framesContainerBackground: "#222222",
      sectionContainerBackground: "#000000",
      showLaneNumber: true,
      playerName: {
        fontColor: "#7ed321",
        fontSize: "20px",
        fontBold: false,
      },
      bowlingcenter: {
        fontColor: "#ffffff",
        fontSize: "13px",
        fontBold: false,
      },
      totalScore: {
        fontColor: "#ffffff",
        fontSize: "13px",
        fontBold: false,
      },
      innerBackground: `rgba(126, 211, 33, 0.2)`,
    },
  },
];

const replace = (array, item) => {
  const i = array.findIndex((setting) => setting.type === item.type);
  if (i > -1) array[i] = item;
  return array;
};

export function scoreCardSettings(store) {
  store.on("@init", () => {
    return { scoreCardSettings: initState };
  });

  store.on(APPLY_SETTINGS_CARD, ({ scoreCardSettings }, data) => {
    const temp = [...scoreCardSettings];
    if (data) {
      replace(temp, formatLoadedData(data));
    }
    localStorage.setItem("scoreCardSettings", JSON.stringify([...temp]));
    return { scoreCardSettings: [...temp] };
  });

  store.on(LOAD_SETTINGS_CARD, async ({ auth }, { history }) => {
    if (auth) {
      const res = await loadCardSettings(auth);
      if (res.success === false && res.message === "Not Valid Token") {
        history.push("/login");
      }
      store.dispatch(APPLY_SETTINGS_CARD, res);
    }
  });

  store.on(
    SAVE_SETTINGS_CARD,
    async ({ scoreCardSettings, auth }, { data, history }) => {
      try {
        if (auth) {
          const settingsData = formatDataToSave(data);
          const res = await saveCardSettings(auth, settingsData);
          store.dispatch(APPLY_SETTINGS_CARD, res);
          history.push("/live-score-players");
        }
      } catch (error) {
        console.log(error);
      }
    }
  );

  const fn = (key) => key.replace(/_([a-z])/g, (_, m) => m.toUpperCase());
  const reverse_fn = (key) =>
    key === "currentFrame"
      ? key
      : key.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);

  // trasnforms an object based on the replacer function provided
  const transform = (o, replacer) =>
    Object.fromEntries(
      Object.entries(o).map(([k, v]) => [replacer(k), processVal(v, replacer)])
    );

  const processVal = (val, replacer) =>
    typeof val !== "object"
      ? val
      : Array.isArray(val)
      ? val.map(transform(val, replacer))
      : transform(val, replacer);

  const formatDataToSave = (data) => {
    return transform(data, reverse_fn);
  };

  const formatLoadedData = (data) => {
    return transform(data, fn);
  };
}
